import { deepFeatures } from "@/mocks/ranking";

export default function DeepFeatures() {
  return (
    <section id="deep" className="mx-auto w-full max-w-7xl scroll-mt-16 px-4 py-12 md:px-6 md:py-16">
      <div className="flex items-end justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-bold tracking-widest text-primary-700">
            <i className="ri-book-open-line"></i>
            深度补课
          </span>
          <h2 className="mt-4 font-serif text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            别只看热搜标题，来补课
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            把零散的热点串成完整故事线，从起因、发酵到收场一次讲清楚，看完你就是朋友圈最懂瓜的人。
          </p>
        </div>
        <a
          href="#about"
          className="hidden items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700 md:inline-flex"
        >
          查看补课索引
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="mt-8 grid gap-5 md:grid-cols-3">
        {deepFeatures.map((f) => (
          <article
            key={f.id}
            className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50"
          >
            <a href="#about" className="block overflow-hidden">
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={f.image}
                  alt={f.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/80 px-3 py-1 text-xs font-semibold text-background-50">
                  {f.theme}
                </span>
              </div>
            </a>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-serif text-lg font-bold leading-snug text-foreground-950">
                <a href="#about" className="hover:text-primary-700">
                  {f.title}
                </a>
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {f.excerpt}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line"></i>
                  {f.minutes}
                </span>
                <span className="flex items-center gap-1 font-semibold text-primary-600">
                  开始补课
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}